import './index.scss'
wp.blocks.registerBlockStyle(
  'core/query-pagination',
  {
    name: 'shadow-pagination',
    label: 'Shadow Pagination'
  }
);


wp.blocks.registerBlockStyle(
  'core/query-pagination',
  {
    name: 'block-pagination',
    label: 'Block Pagination'
  }
);

